var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"GenericView"},[_c(_vm.comp,_vm._b({tag:"component",staticClass:"inner"},'component',_vm.props,false)),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }